import { generatePath } from "@routes/utils";
import type { IExtractParams } from "@routes/types";

const pathBase = `/papers/`;
const pathById = `${pathBase}:paperId/`;

export type IPaperPathParam = IExtractParams<typeof pathById>;

export const papers = {
  getAll: () => generatePath(pathBase, null),
  post: () => generatePath(pathBase, null),
  get: (param: IPaperPathParam) => generatePath(pathById, param),
  put: (param: IPaperPathParam) => generatePath(pathById, param),
  patch: (param: IPaperPathParam) => generatePath(pathById, param),
  delete: (param: IPaperPathParam) => generatePath(pathById, param),
};
